<template>
  <div class="mapBox">
    <div ref="mymap" class="myMap"></div>
    <div class="mapSearch">
      <input type="text" v-model="searchFilter" placeholder="搜索地图名称等关键词" class="searchInput">
      <div class="searchSelectBox">
        <img src="@/assets/images/icon38.png" alt="" @click="searchClick">
        <el-select v-model="selectIndex" placeholder="选择索引">
            <el-option
              v-for="item in indexLists"
              :key="item.id"
              :label="item.indexLogicname"
              :value="item.id">
            </el-option>
          </el-select>
      </div>
      <!-- <button @click="search" style="line-height:0;"><img src="@/assets/images/icon05.png" alt=""></button> -->
    </div>
    <ul class="pointList" v-show="isShow">
      <span @click.stop="closeSearchList" class="closeSearchList">
        <img src="@/assets/images/icon42.png" alt="" class="icon" style="width:14px;">
      </span>
      <div class="listPanel">
        <li v-for="(item,index) in pointLists" :key="item.value" class="clearfix" style="cursor: pointer;" @click="itemClick(item)">
            <div class="pointNum">{{index + 1}}</div>
            <div class="pointMsg">
              <h4>{{item.identityMap.label}}</h4>
              <p>{{item.identityMap.tableName}}</p>
              <!-- <p>{{item.identityMap.name}}</p> -->
            </div>
        </li>
      </div>
      <el-pagination
        @prev-click="pageChange"
        @next-click="pageChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :pager-count="5"
        class="paginationBox"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </ul>

    <el-button v-if="isFlag" v-show="mapNum" ref="layerManagerBtn" style="height:auto!important" 
    :icon="[isShowLayerManager?'el-icon-search1':'el-icon-search']" :class="['layerManagerBtn',{'layerManagerBtn1':isShowLayerManager}]" @click="layerManagerBtnClick">
      图层<img src="@/assets/images/icon16.png" alt="" :class="[isShowLayerManager?'upArrow':'downArrow']">
    </el-button>
    <div class="layerManager" v-show="isShowLayerManager" v-if="ifHasLayer">
      <li class="checkboxList" v-for="(item,index) in layerList" :key='index'>
         <el-checkbox class="checkbox" v-model="item.checked" @change="setVisibilityLayer(item)">{{item.serviceCname}}</el-checkbox>
      </li>
    </div>

    <tool-bar :propsParam = "toolBarPropsParam" v-if="isFlag"></tool-bar>
    <login-box v-show="showORhide" @closeLoginBoxX="closeLoginBoxX" :mapLoginOrindLogin="mapLoginOrindLogin"></login-box>
    <img src="@/assets/images/icon10.png" alt="" class="personCenter" v-if="ifLogin" @click="personCenter">
    <img src="@/assets/images/icon39.png" alt="" class="personCenter" v-else @click="personCenter">
    <img src="@/assets/images/icon11.png" alt="" class="backHome" @click="backHome">
  </div>
</template>

<script>
import request from '@/utils/request';
import toolBar from './toolBar';
import common from './../../../public/arcgisjs/common.js';
// import $ from 'jQuery';
import { loadCss, loadModules } from 'esri-loader';
import { parse } from 'path';
import { get } from 'http';
import loginBox from '@/views/components/loginBox'
export default {
  name: 'mapShow',
  components:{
    toolBar,
    loginBox
  },
  data(){
    return {
      mapNum:false,
      mapLoginOrindLogin:2,
      showORhide:false,
      ifHasLayer:false,
      loadingInstance:null,
      currentPage:1,
      total:10,
      isAddSuccess:true,
      ifLogin:false,
      spatialReference:null,
      layerInfos:[],
      indexLists: [],
      layerList:[],
      graphicsLayer:null,
      pointsLayer:null,
      layerValue:'',
      selectIndex:'',
      isShow:false,
      isFlag:false,
      isShowLayerManager:false,
      toolBarPropsParam:{},
      searchFilter:'',
      pointLists:[],
      map:null,
      options:null,
      gisConstructor: {}, //gis 构造函数
      layerExtent:[],
      bastSpatialReference:null,
      gisModules: [
        "dojo/on",
        "dojo/_base/lang",
        "esri/map",
        "esri/layers/ArcGISTiledMapServiceLayer",
        "esri/layers/ArcGISImageServiceLayer",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/symbols/PictureMarkerSymbol",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleMarkerSymbol", 
        "esri/symbols/SimpleLineSymbol",
        "esri/symbols/TextSymbol",
        "esri/Color",
        "esri/symbols/Font",
        "esri/layers/GraphicsLayer",
        "esri/graphic",
        "esri/geometry/Point",
        "esri/geometry/Polyline",
        "esri/geometry/Polygon",
        "esri/layers/ImageServiceParameters",
        "esri/SpatialReference",
        "esri/geometry/Extent",
        "esri/geometry/webMercatorUtils",       
        "esri/tasks/GeometryService",
        "esri/tasks/ProjectParameters",
      ]
    }
  },
  created(){
    let mapNumNow = localStorage.getItem('mapNum');
    if(mapNumNow == 1){
      this.mapNum = true;
    }else{
      this.mapNum = false;
    }
    
  },
  mounted(){
      // 加载css
      common.appConfig = common.getConfig();
      this.options = this.$route.query;
      let restUrl = new URL(this.options.restUrl);
      let geometryService = restUrl.protocol+"//"+ restUrl.host +"/arcgis/rest/services/Utilities/Geometry/GeometryServer";
      common.appConfig.geometryService = geometryService;
      window.common = common;
      loadCss('./../../../arcgisjs/arcgis_js_api/3.26/library/3.26compact/esri/css/esri.css');
      const dojoConfig = {
        url: "./../../../arcgisjs/arcgis_js_api/3.26/library/3.26compact/init.js",
        dojoConfig:{
            parseOnLoad: true,
            async: true,
            packages: [{ 
                name: '',
                location: ""
            }] 
        }
      }
      // 加载模块
      loadModules(this.gisModules, dojoConfig).then(this.instance).then(this.createMap);
      if(!common.isStringNullOrEmpty(this.options.indexid)){
        this.selectIndex = this.options.indexid;
      }
      if(!common.isStringNullOrEmpty(this.options.searchFilter)){
        this.searchFilter = this.options.searchFilter;
      }
      if(!this.options.indexList){
          this.getIndexList();
      }else{
          this.indexLists = this.options.indexList;
      }
      this.getLayersList();
      let portalToken =  localStorage.getItem('portalToken');
      if(portalToken){
        this.ifLogin = true;
      }else{
        this.ifLogin = false;
      }
  },
  methods:{
    //关闭搜索结果弹框
    closeSearchList(){
      this.isShow = false;
    },
    //关闭登录弹框
    closeLoginBoxX(val){
      this.showORhide = val;
    },
    instance(args) {
      // 这里处理了一下传参，构造函数全部保存到 gisConstructor 对象中，对应的函数
      // key 值为加载模块的最后一个单词
      // 注意大小写，3.x 的API感觉有点乱，API文件的开头有大写有小写，注意一定对应起来，
      // 比如 map.js 和 graphic.js 的文件名的开头就是小写的，
      for (let k in args) {
          let name = this.gisModules[k].split('/').pop();
          this.gisConstructor[name] = args[k];
      }
    },



    //创建地图
    createMap(){
      this.map = new this.gisConstructor.map(this.$refs.mymap,{
          logo: false,
          slider: false,
          minZoom:1,
          maxZoom:17,
          
           
      });
       
        this.gisConstructor.on(this.map,"load",this.gisConstructor.lang.hitch(this,function(evt){
            this.graphicsLayer = new this.gisConstructor.GraphicsLayer();
            this.pointsLayer = new this.gisConstructor.GraphicsLayer();
            this.map.addLayer(this.graphicsLayer);
            this.map.addLayer(this.pointsLayer);
            this.bastSpatialReference=this.map.spatialReference;
            this.toolBarPropsParam.map = this.map;
            this.isFlag = true;
            
             if(this.searchFilter!=''){
                 this.searchClick()
             }
             
        })); 
        this.addLayer(this.options);
      
    },
    //添加图层
    addLayer(item){
     
        //地图服务
        let layer;
        let serviceType = item.typeName;
        if(serviceType.indexOf('ImageServer') != -1){
          let params = new this.gisConstructor.ImageServiceParameters();
          params.noData = 0;
          layer = new this.gisConstructor.ArcGISImageServiceLayer(item.restUrl,{imageServiceParameters: params,
                        opacity: 0.75,
                        id:"layer_" + item.id});
        }else if(serviceType.indexOf('MapServer') != -1){
          if(!common.isStringNullOrEmpty(item.ifCaching)){
            if(item.ifCaching == "0"){
              layer = new this.gisConstructor.ArcGISDynamicMapServiceLayer(item.restUrl,{id:"layer_" + item.id });
            }else if(item.ifCaching == "1"){
              layer = new this.gisConstructor.ArcGISTiledMapServiceLayer(item.restUrl,{id:"layer_" + item.id});
            }
          }
        }
        this.map.addLayer(layer);

        //图层定位
        if(this.bastSpatialReference!=null){
          let mapsspatialReference
          if(this.bastSpatialReference.wkt!=null){
            mapsspatialReference=new this.gisConstructor.SpatialReference(this.bastSpatialReference)

          }else{
            mapsspatialReference=new this.gisConstructor.SpatialReference({ wkid: 4326 })
          }
           let extent = new this.gisConstructor.Extent(Number(item.xmin),
                Number(item.ymin),
                Number(item.xmax),
                Number(item.ymax),mapsspatialReference);
                 this.map.setExtent(extent);
        }
        //添加图层
        if(!common.isStringNullOrEmpty(item.xmin)
          && !common.isStringNullOrEmpty(item.ymin) 
          && !common.isStringNullOrEmpty(item.xmax) 
          &&!common.isStringNullOrEmpty(item.ymax)){
              let extent = new this.gisConstructor.Extent(
                Number(item.xmin),
                Number(item.ymin),
                Number(item.xmax),
                Number(item.ymax),
                this.map.spatialReference);
              var extentMap={};
              extentMap.id=item.id;
              extentMap.extent=extent;
              this.layerExtent.push(extentMap); 
        }
       
    },
    //查询索引
    getIndexList(){
      let params = {
        is_deleted:0,
        createUser:JSON.parse(localStorage.getItem('portalUserName'))
      }
      request({url:'/portal/myindex/find',method:'post',data:params})
      .then(res => {
          if(res.data.code == 200){
            this.indexLists = res.data.data.records;
            this.selectIndex = this.indexLists[0].id;
          }
      })
      .catch(err => {
          console.log(err);
      })
      
    },
    //查询图层列表
    getLayersList(){
        let params = {
          mapType:"02"
        }
        request({url:'/portalmap/gisServerController/findmapserver',method:'post',params:params})
        .then(res => {
            if(res.data.code == 200){
              for(let p in res.data.data){
                res.data.data[p].checked = false;
              }
              this.layerList = res.data.data;
              if(this.layerList.length < 1){
                this.ifHasLayer = false;
              }else{
                this.ifHasLayer = true;
              }
            }
        })
        .catch(err => {
            console.log(err);
        })
    },
    layerManagerBtnClick(){
       this.isShowLayerManager = !this.isShowLayerManager;
    },
    //分页
    pageChange(page){
      this.currentPage = page;
      this.search()
    },
    searchClick(){
      this.search();
    },

    //查询
    search(){
        window.currentMapTool = null;//避免有工具在使用
        if(common.isStringNullOrEmpty($.trim(this.searchFilter))){
          this.$message({
                message: '请输入搜索条件',
                type: 'warning'
              });
          return
        }else if(this.selectIndex == ''){
          this.$message({
                message: '请选择索引',
                type: 'warning'
          });
          return
        }
        let extent = this.map.extent;
        var geoservice = new this.gisConstructor.GeometryService(common.appConfig.geometryService);
        var PrjParams = new this.gisConstructor.ProjectParameters();
        PrjParams.outSR = new this.gisConstructor.SpatialReference({wkid: 4326});//需要输出的坐标系

        PrjParams.geometries = [];//几何类型数组，比如多个点可以批量转换
        // var point1 = new this.gisConstructor.Point(extent.xmin, extent.ymin, new this.gisConstructor.SpatialReference({ wkid: extent.spatialReference.wkid }));
        // var point2 = new this.gisConstructor.Point(extent.xmax, extent.ymax, new this.gisConstructor.SpatialReference({ wkid: extent.spatialReference.wkid }));
        var point1 = new this.gisConstructor.Point(extent.xmin, extent.ymin, extent.spatialReference);
        var point2 = new this.gisConstructor.Point(extent.xmax, extent.ymax, extent.spatialReference);
        PrjParams.geometries.push(point1);
        PrjParams.geometries.push(point2);

        //点的坐标转换，转为地理坐标(wkid:4326)
        geoservice.project(PrjParams, outputpoints=> {
            let params = {
              text:$.trim(this.searchFilter),
              indexid:this.selectIndex,
              size:10,
              cur:this.currentPage,
              //range:{minLat:extent.ymin,minLon:extent.xmin,maxLat:extent.ymax,maxLon:extent.xmax}
              range:{minLat:outputpoints[0].y,minLon:outputpoints[0].x,maxLat:outputpoints[1].y,maxLon:outputpoints[1].x}
            }
            request({url:'/portal/myindex/searchMultiIndex',method:'post',params:params})
            .then(res => {
                if(res && res.data && res.data.code == 200){
                  let data = res.data.data.data
                  this.total = res.data.data.totalCount;
                  if(data.length > 0){
                    this.isShow = true; 
                    this.pointLists = data;
                    this.addPoints(data);
                  }else{
                    this.$message({
                      message: '未检索到数据。',
                      type: 'warning'
                    });
                    this.pointLists = [];
                    this.isShow = false;
                  }
                }else{
                  this.$message({
                    message:'地图范围过大，请缩小范围检索',
                    type: 'warning'
                  });
                  this.pointLists = [];
                  this.isShow = false;
                }
            }) 


        });

           
    },
    itemClick(item){//点击定位
    let mapsspatialReference
          if(this.bastSpatialReference.wkt!=null){
            mapsspatialReference=new this.gisConstructor.SpatialReference(this.bastSpatialReference)

          }else{
            mapsspatialReference=new this.gisConstructor.SpatialReference({ wkid: 4326 })
          }
      let centerPoint = new this.gisConstructor.Point(item.identityMap.center,mapsspatialReference);
      this.showInfoWindow(item,centerPoint);
      this.map.centerAt(centerPoint);
      this.changePointSymbol(item.identityMap.id);
      this.drawGraphics(item.geometry);
    },
    //添加graphic
    addPoints(data){
      this.pointsLayer.clear();
      //点
      for(let p in data){
          let geometry;
          let feature = data[p];
          let attr = feature;
          let pointSymbol = new this.gisConstructor.PictureMarkerSymbol('/images/icon09.png', 22, 29);
          geometry = new this.gisConstructor.Point(feature.identityMap.center);
          let graphic = new this.gisConstructor.graphic(geometry,pointSymbol,attr);
          this.pointsLayer.add(graphic);
          // //数字符号
          let textSymbol = new this.gisConstructor.TextSymbol(Number(p) + 1); 
          let font = new this.gisConstructor.Font();
          font.setSize("10pt");
          textSymbol.setColor(new this.gisConstructor.Color("#FFF"));
          textSymbol.setFont(font);
          let textGraphic = new this.gisConstructor.graphic(geometry,textSymbol,attr);
          this.pointsLayer.add(textGraphic);
      } 

      //监听事件
      this.gisConstructor.on(this.pointsLayer,"mouse-over",this.gisConstructor.lang.hitch(this,function(evt){
          this.map.setMapCursor("pointer");
      }));
      this.gisConstructor.on(this.pointsLayer,"mouse-out",this.gisConstructor.lang.hitch(this,function(evt){
          this.map.setMapCursor("default");
      }));
      this.gisConstructor.on(this.pointsLayer,"click",this.gisConstructor.lang.hitch(this,function(evt){
          if(!window.currentMapTool || window.isBaseTool){
            let attributes = evt.graphic.attributes; 
            let mapsspatialReference
            if(this.bastSpatialReference.wkt!=null){
              mapsspatialReference=new this.gisConstructor.SpatialReference(this.bastSpatialReference)

            }else{
              mapsspatialReference=new this.gisConstructor.SpatialReference({ wkid: 4326 })
            }
            let centerPoint = new this.gisConstructor.Point(attributes.identityMap.center,mapsspatialReference);
            this.showInfoWindow(attributes,centerPoint);
            this.map.centerAt(centerPoint);
            this.changePointSymbol(attributes.identityMap.id);
            this.drawGraphics(attributes.geometry);
          }
      }));
    },
    changePointSymbol(graphicId){
       let graphics = this.pointsLayer.graphics
       for(let p in graphics){
            if(common.isStringNullOrEmpty(graphics[p].symbol.text)){
              let pointSymbol;
              if(graphicId == graphics[p].attributes.identityMap.id){
                pointSymbol = new this.gisConstructor.PictureMarkerSymbol('/images/point.png', 22, 29);
              }else{
                pointSymbol = new this.gisConstructor.PictureMarkerSymbol('/images/icon09.png', 22, 29);
              } 
              graphics[p].symbol = pointSymbol;
            }
        }
        //图层刷新
        this.pointsLayer.redraw();
    },
    drawGraphics(geo){
        this.graphicsLayer.clear();
        let symbol;
        let geometry; 
        if(geo.type == "LineString"){
          symbol = new this.gisConstructor.SimpleLineSymbol(this.gisConstructor.SimpleLineSymbol.STYLE_SOLID,
              new this.gisConstructor.Color("#F54336"), 2);
          geometry = new this.gisConstructor.Polyline(geo.coordinates);
        }else if(geo.type == "Polygon" || geo.type == "MultiPolygon"){
          symbol = new this.gisConstructor.SimpleFillSymbol(this.gisConstructor.SimpleFillSymbol.STYLE_SOLID,
            new this.gisConstructor.SimpleLineSymbol(this.gisConstructor.SimpleLineSymbol.STYLE_SOLID,
                  new this.gisConstructor.Color("#F54336"), 2),new this.gisConstructor.Color([245,67,54,0.5]));
          geometry = new this.gisConstructor.Polygon(geo.coordinates);
          let data = geo.coordinates;
          if(geo.type == "MultiPolygon"){//多面
            data = geo.coordinates[0][0];
            let rings = []
            getRings(data,rings);
            let json = {
              hasZ:true,
              hazM:true,
              rings:rings,
              spatialReference:this.map.spatialReference
            }
            geometry = new this.gisConstructor.Polygon(json);
          }else{
            geometry = new this.gisConstructor.Polygon(data);
          }
        }

        let graphic = new this.gisConstructor.graphic(geometry,symbol);
        this.graphicsLayer.add(graphic);

        //处理多环数据
        function getRings(data,rings){
          let data2;
          for(var i= 0,l = data.length;i < l;i++){
              let item  = data[0];//起点
              if(i != l){
                let item1  = data[i+1];//终点
                if(item[0] == item1[0] && item[1] == item1[1]){
                  let data1 = data.slice(0,i+2);
                  rings.push(data1);
                  data2 = data.slice(i+2,l); 
                  break;    
                }
              }
          }
          if(data2.length > 0){
             getRings(data2,rings);
          }  
        }
    },
    //显示InfoWindow
    showInfoWindow(data,mapPoint){
      this.map.infoWindow.setTitle(data.identityMap.label);
      let longitude = Number(data.identityMap.center[0]);
      let latitude = Number(data.identityMap.center[1]);
      //取绝对值
      let lng = this.cacuLonLat(Math.abs(longitude));
      if(longitude < 0){
        lng = "西经-" + lng;
      }else{
        lng = "东经" + lng;;
      }
      //取绝对值
      let lat = this.cacuLonLat(Math.abs(latitude));
      if(latitude < 0){
        lat = "南纬-" + lat;
      }else{
        lat = "北纬" + lat;
      }
      let content = '<p>名称：'+ data.identityMap.label + '</p></br>'
                  +'<p>坐标：'+ lng +' , '+ lat +'</p>'
      this.map.infoWindow.setContent(content);
      let screenP = this.map.toScreen(mapPoint);
      this.map.infoWindow.show(mapPoint, this.map.getInfoWindowAnchor(screenP));
    },
    
    //关闭InfoWindow
    closeInfoWindow(){
      this.map.infoWindow.hide();
      this.map.infoWindow.destroy();
    },
    //返回首页
    backHome(){
      this.$router.push({path:'/'})
    },
    //将经纬度转为度分秒
    cacuLonLat(number) {
      let degree = parseInt(number);
      let min = parseInt((number - degree) * 60);
      let sec = parseInt((number - degree) * 3600 - min * 60);
      return degree + '°' + min + '′' + sec + '″';
    },
    //返回个人中心
    personCenter(){
      let portalToken =  localStorage.getItem('portalToken');
      if(portalToken){
        this.$router.push({path:'/personal'})
      }else{
        this.showORhide = true;
        this.mapLoginOrindLogin = 2;
        // this.$message('请登录后查看！')
        // this.$router.push({path:'/'})
      }
      
    },
    //设置图层显隐
    setVisibilityLayer(item){
        let layer = this.map.getLayer("layer_" + item.id);
        if(layer){
          var layers= this.layerExtent.pop();

          if(this.layerExtent.length==1){
              let extent = new this.gisConstructor.Extent(
                Number(this.layerExtent[0].extent.xmin),
                Number(this.layerExtent[0].extent.ymin),
                Number(this.layerExtent[0].extent.xmax),
                Number(this.layerExtent[0].extent.ymax),
                this.map.spatialReference);
           this.map.setExtent(extent);

          }
         
          this.map.removeLayer(layer)
        }else{   
          this.addLayer(item);
          if(!this.isAddSuccess){
            item.checked = false;
          }
        }
    }
  }
}
</script>

<style scoped>
.mapSearch{position:absolute;left:20px;top:30px;}
.myMap {position: absolute;height:100%;width: 100%;overflow:hidden;}
.mapBox >>> .esriPopup .actionsPane.zoomTo {
     display: none;
}
.mapBox >>> .esriPopup .titleButton.maximize {
     display: none;
}
.mapSearch .searchInput{vertical-align:top;height:32px;width:350px;background:rgba(255,255,255,1);border:0;border-radius:5px 0 0 5px;text-indent:20px;color:#526281;box-shadow:0 0 25px rgba(6,91,164,.3);}
.mapSearch .searchSelectBox{position:relative;vertical-align: top;display:inline-block;cursor:pointer;height:34px;width:100px;background:linear-gradient(to right,#52bdff,#0084ff);border:0;border-radius:0 5px 5px 0;}
.mapSearch .searchSelectBox img{position:absolute;top:6px;left:-35px;width:24px;}
.mapSearch .searchSelectBox >>> .el-input__inner{background:transparent;border:0;color:#fff;height:34px;    font-size: 12px;}
.mapSearch .searchSelectBox >>> .el-input__icon{line-height:34px;}
.mapSearch .searchSelectBox >>> .el-select .el-input .el-select__caret{color:#fff;}
.mapSearch .searchSelectBox >>> .el-input__suffix{right:2px;}
.mapSearch .searchSelectBox >>> input::-webkit-input-placeholder {
  color: #fff;font-size:14px;
}
.mapSearch .searchSelectBox >>> input::-moz-input-placeholder {
  color: #fff;font-size:14px;
}
.mapSearch .searchSelectBox >>> input::-ms-input-placeholder {
  color: #fff;font-size:14px;
}

.layerManagerBtn{
    position: absolute;
    right: 310px;
    top: 30px;
    padding:10px 14px;
    color: #526281;
    cursor: pointer;
    border-radius: 5px;
    /* background:linear-gradient(to right,#52bdff,#0084ff); */
    background:#fff;
    
  }
.layerManagerBtn1{
  color:#0084ff
}
.layerManagerBtn >>> .el-icon-search{
  width:15px;
  content: url('./../../assets/images/icon40.png');
  vertical-align: top;
}
.layerManagerBtn >>> .el-icon-search1{
  width:15px;
  content: url('./../../assets/images/icon40-1.png');
  vertical-align: top;
}
.layerManager{
  position: absolute;
  right: 310px;
  top: 70px;
  background-color: #fff;
  border: 1px solid #DCDFE6;
  border-radius:3px;
  padding: 10px 17px;
  max-height: 400px;
}
.checkboxList{
  text-align: left;
  padding:2px;
}
.pointList{position:absolute;top:80px;left:20px;width:350px;height:80%; box-sizing:border-box;
   background: rgba(255,255,255,.9);box-shadow:0 0 25px rgba(6,91,164,.3);text-align:left;border-radius:5px;}
.listPanel{position: absolute;padding:20px;width: 100%;top: 0px;bottom: 40px;overflow-y: auto;overflow-x: hidden;}
.listPanel li{padding:10px;}
.listPanel li:hover{background:#eee;}
.paginationBox{position:absolute;bottom:10px;left:0;width:100%;text-align:center;height: 30px;}
.pointNum,.pointMsg{float:left;}
.pointNum{width:22px;height:30px;padding-top:2px;margin-right:10px;text-align:center;color:#fff;background:url('./../../assets/images/icon09.png') no-repeat;}
.pointMsg{line-height:24px;font-size:12px;}
.pointMsg h4{color:#0084ff}
.upArrow{transform:rotate(180deg);transition:all .2s linear;margin-left:10px;}
.downArrow{transform:rotate(0);transition:all .2s linear;margin-left:10px;}

.mapBox >>> .esriPopup .titlePane{padding-left:10px;background:#fff;color:#526281;line-height:36px;font-size:16px;font-weight:bold}
.mapBox >>> .esriPopup .contentPane,.mapBox >>> .esriPopup .actionsPane,.mapBox >>> .esriPopup .pointer, .mapBox >>> .esriPopup .outerPointer{background:#fff;color:#526281}
.mapBox >>> .esriPopup .esriPopupWrapper{box-shadow:0 0 0.75em #ccc;}
.mapBox >>> .esriPopup .titleButton {background:url('./../../assets/images/close.png') no-repeat; }
/* .mapBox >>> .esriPopup .pointer.bottomLeft{left:50%;} */
/* .mapBox >>> .esriPopupWrapper{left:-132px!important;bottom:24px!important;} */
#ifHasLayer{border:0}
.closeSearchList{z-index:999;cursor:pointer;position:absolute;right:10px;top:10px;}
</style>
